/** Where the Painel TV lives (the address typed on a TV). Overridable per environment via `VITE_TV_URL`; the staging address by default. */
const DEFAULT_TV_URL = 'https://tv.usevello.app';

/** The address to type on the TV, without protocol or trailing slash (`tv.usevello.app`). */
export function tvHost(): string {
  const env = import.meta.env as { VITE_TV_URL?: string };
  const value = env.VITE_TV_URL;
  return (value !== undefined && value.trim() !== '' ? value : DEFAULT_TV_URL).replace(/^[a-z]+:\/\//i, '').replace(/\/+$/, '');
}
